import React from 'react';

import { Subtitle } from './styles';

const PLANS_FUNCIONALITIES = [
  {
    id: 'visibility',
    title: 'Visibilidade renovada para todos os anúncios',
    content: [
      {
        id: 'visibilidade-renovada',
        title: '',
        subtitle:
          'Com o passar do tempo os anúncios vão perdendo visibilidade na plataforma. Mas, ao contratar um plano na OLX, todos os seus anúncios tem a visibilidade renovada automaticamente pelo menos uma vez após a publicação.',
      },
    ],
    imageUrl: 'https://static.olx.com.br/autos/autos-pro/landing-autos-visibililty.png',
    flexDirection: isMobile => (isMobile ? 'column-reverse' : 'row'),
  },
  {
    id: 'highlightsPRO',
    title: 'Autonomia para aumentar a exposição de anúncios a sua escolha',
    content: [
      {
        id: 'destaque-pro',
        title: 'Destaque PRO',
        subtitle: (
          <Subtitle>
            Opção de destaque avulso criada exclusivamente para os planos OLX. A cada tamanho e tipo de plano, uma quantidade de destaques para que você possa escolher os anúncios para os quais quer dar mais visibilidade.<br />
            Cada destaque PRO retorna <strong>3 vezes ao topo durante 5 dias.</strong>
          </Subtitle>
        ),
      },
      {
        id: 'destaque-vip',
        title: 'Exibição dos anúncios destacados em espaços VIP',
        subtitle: 'Seus anúncios aparecendo em espaços especiais da OLX, em galerias onde mais de 200 mil pessoas acessam todos os dias',
        tag: 'EXCLUSIVO PLANO ESPECIALISTA',
      },
    ],
    imageUrl: 'https://static.olx.com.br/autos/autos-pro/landing-autos-pro.png',
    flexDirection: isMobile => (isMobile ? 'column-reverse' : 'row-reverse'),
  },
  {
    id: 'contactManagement',
    title: 'Gestão inteligente dos contatos',
    content: [
      {
        id: 'contatos-pro-email',
        title: 'Acesso ao telefone e e-mail do interessado',
        subtitle:
          'Você terá acesso aos dados de quem se interessou pelos seus veículos, com todo o cuidado de gestão de informação e de acordo com as diretrizes nacionais de proteção de dados.',
      },
      {
        id: 'contatos-pro-wpp',
        title: 'Contato via WhatsApp',
        subtitle:
          'Utilize um número válido para o WhatsApp e os interessados no seu anúncio poderão negociar diretamente com você por essa ferramenta.',
      },
    ],
    imageUrl: 'https://static.olx.com.br/autos/autos-pro/landing-autos-contact.png',
    flexDirection: isMobile => (isMobile ? 'column-reverse' : 'row'),
  },
  {
    id: 'competitiveAdvantage',
    title: 'Vantagem sobre a concorrência',
    content: [
      {
        id: 'selo-pro',
        title: 'Selo de anunciante qualificado',
        subtitle:
          'A confiabilidade na reputação do seu perfil pode fazer a diferença para que o comprador decida acessar um anúncio seu e fazer um contato.',
      },
      {
        id: 'vitrine-pro',
        title: 'Vitrine',
        subtitle:
          'Nas páginas dos seus anúncios os compradores verão uma galeria com mais anúncios publicados por você e um link direto para sua página na OLX.',
      },
      {
        id: 'concorrencia-zero',
        title: 'Concorrência Zero',
        subtitle:
          'As publicidades e a galeria de anúncios de outros vendedores não serão exibidas nas páginas dos seus anúncios.',
        tag: 'EXCLUSIVO PLANO ESPECIALISTA',
      },
    ],
    imageUrl: 'https://static.olx.com.br/autos/autos-pro/landing-autos-competitive.png',
    flexDirection: isMobile => (isMobile ? 'column-reverse' : 'row-reverse'),
  },
  {
    id: 'inventoryManagement',
    title: 'Parceria na gestão de estoque',
    content: [
      {
        id: 'ad-perfomance',
        title:
          'Análise da performance dos anúncios e orientações para melhoria dos resultados',
        subtitle: 'Orientaremos você a fazer as melhorias certas de acordo com o mapeamento do funil de conversão de cada anúncio (desde as exibições no resultado de busca, passando pela quantidade de visualizações, até o volume de contatos recebidos).',
      },
      {
        id: 'car-vip',
        title:
          'Visão VIP na maior plataforma de compra e venda de veículos do Brasil',
        subtitle: 'Avaliaremos a procura de cada modelo anunciado por você, informaremos o preço médio e facilitaremos o acesso aos anúncios semelhantes de maior e menor preço na sua região.',
        tag: 'EXCLUSIVO PLANO ESPECIALISTA',
      },
    ],
    imageUrl: 'https://static.olx.com.br/autos/autos-pro/landing-autos-warehouse.png',
    flexDirection: isMobile => (isMobile ? 'column-reverse' : 'row'),
  },
];

export default PLANS_FUNCIONALITIES;
